import { Component, OnInit } from '@angular/core';


@Component({
  selector: 'app-blob',
  templateUrl: './blob.component.html',
  styleUrls: ['./blob.component.css']
})
export class BlobComponent implements OnInit {

  constructor() { }

  ngOnInit() {

  }

}
